<template>
  <section class="content">
    <div class="container-fluid">
      <div class="block-header">
        <h2>{{ id ? 'Edit' : 'Tambah' }} Dokumen Pensiun</h2>
      </div>
      <div class="card">
        <div class="header">
          <h2>Form Dokumen Pensiun</h2>
        </div>
        <div class="body">
          <form @submit.prevent="onSubmit">
            <!-- Input Category -->
            <div class="row clearfix">
              <div class="col-lg-2 form-control-label">
                <label>Nama kategori</label>
              </div>
              <div class="col-lg-10">
                <form-line
                  v-model="contents.category"
                  type="text"
                  placeholder="Contoh: Pensiun Normal"
                />
              </div>
            </div>

            <!-- Loop Dokumen -->
            <div v-for="(doc, dIndex) in contents.documents" :key="dIndex" class="mb-4">
              <div class="row clearfix">
                <div class="col-lg-2 form-control-label">
                  <label>Judul Dokumen</label>
                </div>
                <div class="col-lg-10">
                  <form-line
                    v-model="doc.title"
                    type="text"
                    placeholder="Contoh: Pensiun Normal"
                  />
                </div>
              </div>

              <div class="row clearfix mt-2">
                <div class="col-lg-2 form-control-label">
                  <label>Konten</label>
                </div>
                <div class="col-lg-10">
                  <ckeditor v-model="doc.content" :config="config"></ckeditor>
                </div>
              </div>

              <div class="text-right mt-2">
                <button class="btn btn-sm btn-danger" @click.prevent="removeDocument(dIndex)">
                  Hapus Dokumen
                </button>
              </div>
              <hr />
            </div>

            <button class="btn btn-success mb-3" type="button" @click="addDocument">
              Tambah Dokumen
            </button>

            <div class="row clearfix">
              <div class="col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5">
                <button class="btn btn-primary" :disabled="isLoading" type="submit">
                  <i class="material-icons">save</i> Simpan
                </button>
                <button class="btn btn-danger" @click="$router.go(-1)" type="button">
                  <i class="material-icons">cancel</i> Batal
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */

import Ckeditor from "vue-ckeditor2";
import FormLine from "@/components/FormLine.vue";
import api from "@/helper/api";

export default {
  components: { FormLine, ckeditor: Ckeditor },
  data() {
    return {
      id: null,
      isLoading: false,
      contents: {
        category: "",
        documents: [{ title: "", content: "" }]
      },
      config: {
        toolbar: [
          {
            name: "basicstyles",
            items: ["Bold", "Italic", "Underline", "Strike", "RemoveFormat"]
          },
          {
            name: "paragraph",
            items: ["NumberedList", "BulletedList"]
          },
          { name: "clipboard", items: ["Undo", "Redo"] },
          { name: "insert", items: ["Image", "Table"] },
          { name: "document", items: ["Source"] }
        ],
        height: 300
      }
    };
  },
  methods: {
    addDocument() {
      this.contents.documents.push({ title: "", content: "" });
    },
    removeDocument(index) {
      this.contents.documents.splice(index, 1);
    },
    onSubmit() {
      this.isLoading = true;

      var docs = this.contents.documents.map(function (doc) {
        return {
          id: doc.id || null, // untuk update
          title: doc.title,
          content: doc.title === "Formulir" ? null : doc.content
        };
      });

      var data = {
        category: this.contents.category,
        documents: docs
      };

      var url = "/saveFormulirRegistrasi"; // backend menangani insert/update dalam satu endpoint

      var self = this;
      api.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("_token");
      api
        .post(url, data)
        .then(function (result) {
          if (result.data.code === 200) {
            self.$toastr.s("Data berhasil disimpan");
            self.$router.replace("/main/pensiunRegistrasi/pensiuntype");
            location.reload();
          } else {
            self.$toastr.e(result.data.message || "Gagal menyimpan data");
          }
        })
        .catch(function (err) {
          self.$toastr.e("Terjadi kesalahan pada server");
        })
        .finally(function () {
          self.isLoading = false;
        });
    },
    fetchData() {
      var self = this;
      api.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("_token");
      api
        .get("/getformulir/" + this.id)
        .then(function (result) {
          var data = result.data;

          if (
            data &&
            data.content &&
            data.content.length > 0 &&
            data.content[0].pensionType &&
            data.content[0].pensionType.name
          ) {
            self.contents.category = data.content[0].pensionType.name;
          }

          self.contents.documents = data.content.map(function (item) {
            return {
              id: item.id, // agar bisa update
              title: item.title,
              content: item.content
            };
          });
        })
        .catch(function () {
          self.$toastr.e("Gagal mengambil data");
        });
    }
  },
  mounted() {
    this.id = this.$route.params.id;
    if (this.id) {
      this.fetchData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/PensiunRegistrasi/FormPensiunType.vue